import React from 'react';
import { useApp } from '../../context/AppContext';
import { URGENCY_META, CATEGORY_META } from '../../utils/helpers';

export default function IdeaCard({ idea, onApprove, approvingId, onGoToStudio }) {
  const { updateIdea } = useApp();
  const urg       = URGENCY_META[idea.urgency]  || URGENCY_META.anytime;
  const cat       = CATEGORY_META[idea.category] || CATEGORY_META.other;
  const isExpanded = approvingId === idea.id;

  function dismiss() {
    updateIdea(idea.id, { status:'dismissed' }).catch(console.error);
  }

  return (
    <div className={`idea-card ${idea.urgency === 'hot' ? 'hot' : idea.urgency === 'soon' ? 'soon' : ''}`}>
      <div className="ic-top">
        <div className="ic-title">{idea.title}</div>
        <button className="btn btn-ghost btn-xs" onClick={dismiss} title="Dismiss">✕</button>
      </div>

      {idea.ai_why && <div className="ic-why">✨ {idea.ai_why}</div>}

      <div className="ic-meta">
        <span className="ic-tag" style={{ background:cat.bg, color:cat.color }}>{cat.label}</span>
        <span className="ic-tag" style={{ background:urg.bg, color:urg.color }}>{urg.label}</span>
        {idea.customer && (
          <span className="ic-tag" style={{ background:'#f3f4f6', color:'#6b7280' }}>👤 {idea.customer}</span>
        )}
      </div>

      {idea.notes && <div className="ic-notes">{idea.notes}</div>}

      <div className="ic-actions">
        {idea.status === 'new' && (
          <button className="btn btn-primary btn-xs" onClick={() => onApprove(idea.id)}>
            {isExpanded ? 'Close ▲' : 'Approve & Generate ▼'}
          </button>
        )}
        {idea.status === 'done' && (
          <button className="btn btn-outline btn-xs" onClick={() => onGoToStudio(idea.id)}>
            View in Studio →
          </button>
        )}
        {idea.status === 'generating' && (
          <span style={{ fontSize:10.5, color:'var(--caramel)' }}>
            Generating <span className="dots"><i/><i/><i/></span>
          </span>
        )}
      </div>
    </div>
  );
}
